// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q8vwap0 {
  background-color: var(--_18w76bw25);
  padding: var(--_18w76bw9) var(--_18w76bw9) var(--_18w76bwz);
  flex-direction: column;
  width: var(--_18w76bw1q);
  gap: var(--_18w76bwh);
  margin-left: auto;
  margin-right: auto;
}
.q8vwap1 {
  flex-direction: column;
  padding: var(--_18w76bw9) var(--_18w76bwd) var(--_18w76bwd);
  background-color: var(--_18w76bw23);
  min-height: var(--_18w76bw1n);
  width: var(--_18w76bw1u);
}
.q8vwap2 {
  padding: var(--_18w76bwg) var(--_18w76bwy);
  line-height: var(--_18w76bw44);
  border-bottom: 1px solid #d8d8d8;
  width: var(--_18w76bw1u);
}
.q8vwap3 {
  padding: var(--_18w76bwi) var(--_18w76bwy);
  gap: var(--_18w76bwg);
  flex-direction: column;
  min-height: var(--_18w76bw1d);
}
.q8vwap4 {
  flex-direction: column;
  padding: var(--_18w76bwh) var(--_18w76bwy);
  gap: var(--_18w76bwg);
  width: var(--_18w76bw1u);
  margin-top: auto;
}
.q8vwap5 {
  padding-bottom: var(--_18w76bwg);
  padding-left: var(--_18w76bwg);
}
.q8vwap6 {
  width: var(--_18w76bw1u);
}
.q8vwap6:hover {
  text-decoration: none;
}
.q8vwap7 {
  line-height: var(--_18w76bw43);
  color: var(--_18w76bw30);
  border-bottom: 1px solid var(--_18w76bw30);
  text-decoration: none;
}
.q8vwap7:hover {
  text-decoration: none;
}
@media screen and (max-width: 767px) {
  .q8vwap0 {
    padding-top: var(--_18w76bw9);
    padding-bottom: var(--_18w76bws);
    width: var(--_18w76bw1u);
    margin-left: var(--_18w76bw9);
    margin-right: var(--_18w76bw9);
    gap: var(--_18w76bwd);
  }
  .q8vwap1 {
    padding: var(--_18w76bw9);
    height: var(--_18w76bw1t);
    margin: var(--_18w76bw9);
    width: var(--_18w76bw1u);
    min-height: var(--_18w76bw1t);
  }
  .q8vwap2 {
    padding: var(--_18w76bwg);
  }
  .q8vwap3 {
    padding: var(--_18w76bwi) var(--_18w76bwg);
    min-width: var(--_18w76bw1u);
  }
  .q8vwap4 {
    padding: var(--_18w76bwd) var(--_18w76bwh);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,2DAA2D;EAC3D,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,2DAA2D;EAC3D,mCAAmC;EACnC,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,gCAAgC;EAChC,wBAAwB;AAC1B;AACA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,0CAA0C;EAC1C,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;IAC9B,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,wBAAwB;IACxB,wBAAwB;IACxB,6BAA6B;EAC/B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0CAA0C;IAC1C,4BAA4B;EAC9B;EACA;IACE,0CAA0C;EAC5C;AACF","sourcesContent":[".q8vwap0 {\n  background-color: var(--_18w76bw25);\n  padding: var(--_18w76bw9) var(--_18w76bw9) var(--_18w76bwz);\n  flex-direction: column;\n  width: var(--_18w76bw1q);\n  gap: var(--_18w76bwh);\n  margin-left: auto;\n  margin-right: auto;\n}\n.q8vwap1 {\n  flex-direction: column;\n  padding: var(--_18w76bw9) var(--_18w76bwd) var(--_18w76bwd);\n  background-color: var(--_18w76bw23);\n  min-height: var(--_18w76bw1n);\n  width: var(--_18w76bw1u);\n}\n.q8vwap2 {\n  padding: var(--_18w76bwg) var(--_18w76bwy);\n  line-height: var(--_18w76bw44);\n  border-bottom: 1px solid #d8d8d8;\n  width: var(--_18w76bw1u);\n}\n.q8vwap3 {\n  padding: var(--_18w76bwi) var(--_18w76bwy);\n  gap: var(--_18w76bwg);\n  flex-direction: column;\n  min-height: var(--_18w76bw1d);\n}\n.q8vwap4 {\n  flex-direction: column;\n  padding: var(--_18w76bwh) var(--_18w76bwy);\n  gap: var(--_18w76bwg);\n  width: var(--_18w76bw1u);\n  margin-top: auto;\n}\n.q8vwap5 {\n  padding-bottom: var(--_18w76bwg);\n  padding-left: var(--_18w76bwg);\n}\n.q8vwap6 {\n  width: var(--_18w76bw1u);\n}\n.q8vwap6:hover {\n  text-decoration: none;\n}\n.q8vwap7 {\n  line-height: var(--_18w76bw43);\n  color: var(--_18w76bw30);\n  border-bottom: 1px solid var(--_18w76bw30);\n  text-decoration: none;\n}\n.q8vwap7:hover {\n  text-decoration: none;\n}\n@media screen and (max-width: 767px) {\n  .q8vwap0 {\n    padding-top: var(--_18w76bw9);\n    padding-bottom: var(--_18w76bws);\n    width: var(--_18w76bw1u);\n    margin-left: var(--_18w76bw9);\n    margin-right: var(--_18w76bw9);\n    gap: var(--_18w76bwd);\n  }\n  .q8vwap1 {\n    padding: var(--_18w76bw9);\n    height: var(--_18w76bw1t);\n    margin: var(--_18w76bw9);\n    width: var(--_18w76bw1u);\n    min-height: var(--_18w76bw1t);\n  }\n  .q8vwap2 {\n    padding: var(--_18w76bwg);\n  }\n  .q8vwap3 {\n    padding: var(--_18w76bwi) var(--_18w76bwg);\n    min-width: var(--_18w76bw1u);\n  }\n  .q8vwap4 {\n    padding: var(--_18w76bwd) var(--_18w76bwh);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
